const propertiesRequiredIgnore = ['picture', 'expectations2', 'linkedinUrl', 'phoneNumber'];

// we save the correspondence of properties when they are not identical
const mappingFieldSettingAndCoachee = {
  location: 'city',
  scopeId: 'scope',
  seniorityLevel: 'seniorityLevelId',
  department: 'departmentId',
  expectations1: 'expectations',
  targetList: 'objectives',
  leaderEmail: 'managerEmail',
  idNumberSecondary: 'idNumber_secondary',
};

export const mapFormSetting = (formSettingsList) => {
  let result = [];
  if (formSettingsList) {
    result = Object.fromEntries(
      formSettingsList?.formFields.map(({ fieldName, isActivated }) => [fieldName, isActivated])
    );
  }
  return result;
};

export const getRequiredFields = (obj) => {
  let requiredFields = [];

  for (let key in obj) {
    if (obj[key]?.required) {
      requiredFields.push(key);
    }
  }

  return requiredFields;
};

export const getMissingPropertiesCoachee = (requiredProperties, user) => {
  return requiredProperties
    .filter((prop) => !propertiesRequiredIgnore.includes(prop))
    .map((prop) => mappingFieldSettingAndCoachee[prop] || prop)
    .filter((mappedProp) => {
      const value = user[mappedProp];
      return (
        value == null ||
        value === '' ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' && Object.keys(value || {}).length === 0)
      );
    });
};
